<template>
  <div class="pdf-showcase" aria-hidden="true">
    <div class="pdf-stack">
      <!-- Back card: Steel Column Interaction Check (formulas, IS clause) -->
      <div class="pdf-card pdf-card-back">
        <img
          src="@/assets/steel-column-interaction-ratio_1.png"
          alt=""
          class="pdf-img"
        />
      </div>
      <!-- Front card: Purlin Design Summary (all checks pass) -->
      <div class="pdf-card pdf-card-front">
        <img
          src="@/assets/prulin-status-table_1.png"
          alt=""
          class="pdf-img pdf-img-front"
        />
      </div>
    </div>
  </div>
</template>

<style scoped>
.pdf-showcase {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

/*
  Both cards 78% wide so text renders large.
  object-fit: cover + object-position crops to the
  relevant section of each PDF page.
*/
.pdf-stack {
  position: relative;
  width: 100%;
  max-width: 620px;
  height: 460px;
}

.pdf-card {
  background: var(--paper-surface);
  border-radius: var(--radius-control);
  overflow: hidden;
  border: 1px solid color-mix(in srgb, var(--text-primary) 10%, transparent);
  position: absolute;
}

/* Back card: Steel Column page 4 — top-right */
.pdf-card-back {
  top: 0;
  right: 0;
  width: 80%;
  height: 270px;
  z-index: var(--z-base);
  box-shadow: var(--shadow-card);
}

.pdf-card-back .pdf-img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
  /* page 4: Interaction Check is in the bottom 35% of the page */
  object-position: center 85%;
  transform: scale(1.0);
  transform-origin: center 84%;
}

/* Front card: Purlin Design Summary — bottom-left */
.pdf-card-front {
  bottom: 0;
  left: 0;
  width: 84%;
  height: 310px;
  z-index: var(--z-content);
  box-shadow: var(--shadow-hover);
}

.pdf-img-front {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
  /* Design Summary table starts near top of page 2 */
  object-position: center 8%;
  transform: scale(1.14);
  transform-origin: center 10%;
}

/* Mobile: front card only */
@media (max-width: 767px) {
  .pdf-stack {
    height: auto;
  }

  .pdf-card-back {
    display: none;
  }

  .pdf-card-front {
    position: relative;
    width: 100%;
    height: auto;
    bottom: auto;
    left: auto;
  }

  .pdf-img-front {
    height: 250px;
    object-position: center 5%;
    transform: scale(1.08);
    transform-origin: center 8%;
  }
}
</style>
